import request from '@/util/request';
import qs from 'qs';
//房产树一级节点
export const treeByIds = (params, options) =>
  request.get(
    '/api/v4ward/dept/treeByIds',
    Object.assign({}, options, {
      params
    })
  );

export const activityManageSave = (params, options) =>
  request.post('/api/v4ward/activity/manage/save', params, options);

  export const activityManageUpdate = (params, options) =>
  request.post('/api/v4ward/activity/manage/update', params, options);
  export const activityManagePage = (params, options) =>
  request.get(
    '/api/v4ward/activity/manage/page',
    Object.assign({}, options, {
      params
    })
  );

  export const activityManageDetail = (params, options) =>
  request.get(
    '/api/v4ward/activity/manage/detail',
    Object.assign({}, options, {
      params
    })
  );

export const smartDeviceUpdate = (params, options) =>
  request.post('/api/v4ward/activity/manage/save', params, options);
  export const show = (id) =>
  request.post('/api/v4ward/activity/manage/show?id='+ id);

  export const notShow = (id) =>
  request.post('/api/v4ward/activity/manage/notShow?id='+ id);

  export const pushAct = (id) =>
  request.post('/api/v4ward/activity/manage/push?id='+ id);

  export const remove = (id) =>
  request.post('/api/v4ward/activity/manage/remove?ids='+ id);

  export const activeSummarize = (params, options) =>
  request.post('/api/v4ward/activity/manage/summary', params, options);

  export const wonderfulReview = (params, options) =>
  request.post('/api/v4ward/activity/manage/review', params, options);
  
  export const getAuxField = (params, options) =>
    request.get(
      '/api/v4ward/activity/manage/aux-field',
      Object.assign({}, options, {
        params
      })
    );